<template>
    <div class="collection-center">
        <div class="tabs">
            <v-btn
                :class="['colle-item', isFavorites && 'active']"
                @click="show_favorites"
                >{{ $TL.favorites }}</v-btn
            >
            <v-btn
                :class="['img-item', !isFavorites && 'active']"
                @click="show_picture_list"
                >{{ $TL.picture }}</v-btn
            >
        </div>
        <favoritesContent v-if="isFavorites" />
        <picturesContent v-else />
    </div>
</template>

<script>
import favoritesContent from "./components/favorites-content";
import picturesContent from "./components/pictures-content";

export default {
    name: "collection-center",

    data() {
        return {
            active: "",
            isFavorites: true
        };
    },
    computed: {},
    components: { favoritesContent, picturesContent },
    created() {},
    mounted() {},
    beforeDestroy() {},
    methods: {
        show_favorites() {
            this.isFavorites = true;
        },
        show_picture_list() {
            this.isFavorites = false;
            //  关闭图片详情弹框
            this.$store.state.vModal.openPictureModal = false;
        }
    }
};
</script>

<style lang="scss">
.collection-center {
    .tabs {
        margin: {
            top: 28px;
            bottom: 12px;
        }
        @include flex(center, center);
        .v-btn {
            margin: 0 8px;
            position: relative;
            padding: 3px 10px;
            border-radius: 4px;
            &:before {
                content: "";
                display: block;
                width: 0;
                height: 2px;
                position: absolute;
                left: 0;
                right: 0;
                top: auto;
                bottom: -4px;
                margin: auto;
            }

            span {
                font-size: 16px;
            }

            &.active {
                color: #2874e5;

                &:before {
                    content: "";
                    width: 100%;
                    background-color: #2874e5;
                    border-radius: 4px 4px 0 0;
                    opacity: 1;

                    transition: all 0.3s cubic-bezier(0.4, 0, 0.6, 1);
                }
            }
        }
    }

    @media (min-width: 1650px) {
        .container {
            max-width: 92%;
        }
    }
}
</style>
